import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { Address } from '../../feature/types/generic';

export interface ExperienceFilters extends MapBounds {
    type: string[];
    state: string[];
    suburb: string[];
    guests: string;
    overnightGuests: string;
    bedrooms: string;
    visitType: string;
    amenities: string[];
    checkinDate: string;
    checkoutDate: string;
    rating: string;
    wishlist: boolean;
    bounds?: google.maps.LatLngBounds;
}

interface MapBounds {
    swLat?: number;
    swLng?: number;
    neLat?: number;
    neLng?: number;
}

const initialState: { value: ExperienceFilters } = {
    value: {
        type: [],
        state: [],
        suburb: [],
        guests: '',
        overnightGuests: '',
        bedrooms: '',
        rating: '',
        visitType: '',
        amenities: [],
        checkinDate: '',
        checkoutDate: '',
        wishlist: false,
        bounds: undefined,
        swLat: undefined,
        swLng: undefined,
        neLat: undefined,
        neLng: undefined,
    },
};

const slice = createSlice({
    name: 'experienceFilters',
    initialState,
    reducers: {
        setExperienceFilters: (
            state,
            action: PayloadAction<ExperienceFilters>,
        ) => {
            state.value = action.payload;
        },
        resetExperienceFilters: (state) => {
            state.value = initialState.value;
        },
    },
});

export const { setExperienceFilters, resetExperienceFilters } = slice.actions;
export const selectExperienceFilters = (state: RootState) =>
    state.experienceFilters.value;
export const ExperienceFiltersReducer = slice.reducer;
